import { Paragraph } from '../components/elements/atoms/paragraph/Paragraph';
import { Modal } from '../components/elements/molecules/modal/Modal';
import { LoginForm } from '../components/elements/organisms/loginForm/LoginForm';

export function TimeoutModal() {
    return (
        <Modal
            bgColor="warning"
            handleClose={() => null}
            isOpen={true}
            size="xsmall"
            title="De sessie is verlopen"
        >
            <Paragraph>Om je gegevens te beschermen ben je na 15 minuten inactiviteit uitgelogd.</Paragraph>
            <LoginForm submitButtonText="Log opnieuw in met DigiD"></LoginForm>
        </Modal>
    );
}
